import React from "react";
import { NavLink } from "react-router-dom";

import {
  Button,
  ButtonVariant,
  Flex,
  FlexItem,
} from "@patternfly/react-core";

import {
  AngleRightIcon,
  ExternalLinkAltIcon,
} from "@patternfly/react-icons";

import { Icons } from "shared/components/Icons";

import "./SchoolMobileListItem.css";

const SchoolMobileListItem = ({
  label,
  to,
  icon,
  external = false,
  hasChildren = false,
  onClick,
}) => {
  const renderedIcon = icon ? Icons[icon] : null;

  const content = (
    <Flex
      justifyContent={{ default: "justifyContentSpaceBetween" }}
      alignItems={{ default: "alignItemsCenter" }}
      className="school-mobile-list-item__content"
    >
      <FlexItem grow={{ default: "grow" }}>
        <div className="school-mobile-list-item__left">
          {renderedIcon && (
            <span className="school-mobile-list-item__icon">
              {renderedIcon}
            </span>
          )}

          <span className="school-mobile-list-item__label">
            {label}
          </span>
        </div>
      </FlexItem>

      <FlexItem>
        {hasChildren && <AngleRightIcon />}

        {!hasChildren && external && (
          <ExternalLinkAltIcon />
        )}
      </FlexItem>
    </Flex>
  );

  if (to) {
    return (
      <Button
        component={(props) => (
          <NavLink
            {...props}
            to={to}
          />
        )}
        variant={ButtonVariant.plain}
        className="school-mobile-list-item"
        onClick={onClick}
      >
        {content}
      </Button>
    );
  }

  return (
    <Button
      variant={ButtonVariant.plain}
      className="school-mobile-list-item"
      onClick={onClick}
    >
      {content}
    </Button>
  );
};

export default SchoolMobileListItem;